import * as React from "react"
import { Route, Switch } from "react-router-dom"
import ExpensesApplication from "src/frontend/components/OS/Applications/Analysis/Expenses/ExpensesApplication"
import RevenueApplication from "src/frontend/components/OS/Applications/Analysis/Revenue/RevenueApplication"
import routes from "src/frontend/routes"

/*
 COMPONENTS
*/

const AnalysisApplication: React.FC = () => (
  <Switch>
    <Route path={routes.expenses.parameterizedPath} component={ExpensesApplication} />
    <Route path={routes.revenue.parameterizedPath} component={RevenueApplication} />
  </Switch>
)

export default AnalysisApplication
